export default "__VITE_ASSET__ZuChNGBk__"